import type { FC, ReactElement } from "react";
import { useMemo } from "react";

import { ConditionCard } from "app/pages/sales-intelligence/common-components/filters-panel";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import type { TechnologiesFilterDto } from "../../types/technologies";

interface IInclusionTechnologiesChipProps {
    item: TechnologiesFilterDto;
    hideActionButton?: boolean;
    onEdit: (item: TechnologiesFilterDto) => void;
    onDelete: (item: TechnologiesFilterDto) => void;
}

const InclusionTechnologiesChip: FC<IInclusionTechnologiesChipProps> = ({
    item,
    hideActionButton = false,
    onEdit,
    onDelete,
}): ReactElement => {
    const values = useMemo(
        (): string[] => [...item.parentCategories, ...item.categories, ...item.technologies],
        [item],
    );

    return (
        <ConditionCard
            inclusionLabel={<I18n translatable={{ key: `si.common.inclusions.${item.inclusion}` }} />}
            values={values}
            hideActions={hideActionButton}
            onEdit={() => onEdit(item)}
            onDelete={() => onDelete(item)}
            dataAutomation="technologies-inclusion-chip"
        />
    );
};

export default InclusionTechnologiesChip;
